import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LldRecapComponent, MaApRecapComponent, MaLtRecapComponent, WedgeTableComponent } from '../../correction';
import { ApexTableComponent, LldTableComponent, MaApTableComponent, MaLtTableComponent } from '../../deformity';
import { BaseComponent } from '../../shared';


/**
 * Second left vertical bar.
 */
@Component({
	selector: 'drawer',
	templateUrl: './drawer.component.html',
	imports: [
		LldTableComponent,
		LldRecapComponent,
		MaLtRecapComponent,
		MaApTableComponent,
		MaApRecapComponent,
		MaLtTableComponent,
		ApexTableComponent,
		WedgeTableComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class DrawerComponent extends BaseComponent {

	isDeformityDrawerOpen = false;
	isCorrectionDrawerOpen = false;

}
